import { render, staticRenderFns } from "./TraditionalEnterprise.vue?vue&type=template&id=83ed28d2&scoped=true&"
import script from "./TraditionalEnterprise.vue?vue&type=script&lang=js&"
export * from "./TraditionalEnterprise.vue?vue&type=script&lang=js&"
import style0 from "./TraditionalEnterprise.vue?vue&type=style&index=0&id=83ed28d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ed28d2",
  null
  
)

export default component.exports